import { createFileRoute } from '@tanstack/react-router';

import { AgencyClients } from '@/components/agency/agency-clients';
import { loadNamespaces } from '@/lib/i18n/i18n';

export const Route = createFileRoute('/_authenticated/agency/clients')({
  loader: () => loadNamespaces('agency'),
  staticData: {
    title: 'route.agency_clients.title',
  },
  component: AgencyClients,
});
